module.exports = __webpack_public_path__ + "img/icon-error.bc1a2145.svg";